/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, February 2020
 */
/**
 * Function to handle signal emits.
 */
export type SignalHandler<T> = {
    once?: boolean;
    (...args: T[]): void;
};

/**
 * A blazing fast implementation of the Observer pattern using signals.
 */
export class Signal<T> {
    private handlers = new Set<SignalHandler<T>>();

    /**
     * Add a listener function.
     *
     * @param fn Function called when the signal is emitted.
     */
    public on(fn: SignalHandler<T>): void {
        this.handlers.add(fn);
    }

    /**
     * Add a listener function that only listens to one signal an then detaches.
     *
     * @param fn Function called when the signal is emitted.
     */
    public once(fn: SignalHandler<T>): void {
        fn.once = true;
        this.handlers.add(fn);
    }

    /**
     * Detach a listener from the signal.
     *
     * @param fn A reference to the listener to detach.
     */
    public off(fn: SignalHandler<T>): void {
        this.handlers.delete(fn);
    }

    /**
     * Emit a signal to all registered listeners with the given arguments
     *
     * @param args Arguments to pass to the listeners.
     */
    public emit(...args: T[]): void {
        for (const handler of this.handlers) {
            handler.apply(this, args);

            if (handler.once) {
                this.handlers.delete(handler);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/signals/Signal.ts